/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetRemoteSessionAutoRefreshPolicyRequestBody,
  SetRemoteSessionAutoRefreshPolicyRequestBody$Outbound,
  SetRemoteSessionAutoRefreshPolicyRequestBody$outboundSchema,
} from "../components/setremotesessionautorefreshpolicyrequestbody.js";

export type SetRemoteSessionAutoRefreshPolicySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetRemoteSessionAutoRefreshPolicyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setRemoteSessionAutoRefreshPolicyRequestBody:
    SetRemoteSessionAutoRefreshPolicyRequestBody;
};

/** @internal */
export type SetRemoteSessionAutoRefreshPolicySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetRemoteSessionAutoRefreshPolicySecurity$outboundSchema:
  z.ZodMiniType<
    SetRemoteSessionAutoRefreshPolicySecurity$Outbound,
    SetRemoteSessionAutoRefreshPolicySecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setRemoteSessionAutoRefreshPolicySecurityToJSON(
  setRemoteSessionAutoRefreshPolicySecurity:
    SetRemoteSessionAutoRefreshPolicySecurity,
): string {
  return JSON.stringify(
    SetRemoteSessionAutoRefreshPolicySecurity$outboundSchema.parse(
      setRemoteSessionAutoRefreshPolicySecurity,
    ),
  );
}

/** @internal */
export type SetRemoteSessionAutoRefreshPolicyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetRemoteSessionAutoRefreshPolicyRequestBody:
    SetRemoteSessionAutoRefreshPolicyRequestBody$Outbound;
};

/** @internal */
export const SetRemoteSessionAutoRefreshPolicyRequest$outboundSchema:
  z.ZodMiniType<
    SetRemoteSessionAutoRefreshPolicyRequest$Outbound,
    SetRemoteSessionAutoRefreshPolicyRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      setRemoteSessionAutoRefreshPolicyRequestBody:
        SetRemoteSessionAutoRefreshPolicyRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        setRemoteSessionAutoRefreshPolicyRequestBody:
          "SetRemoteSessionAutoRefreshPolicyRequestBody",
      });
    }),
  );

export function setRemoteSessionAutoRefreshPolicyRequestToJSON(
  setRemoteSessionAutoRefreshPolicyRequest:
    SetRemoteSessionAutoRefreshPolicyRequest,
): string {
  return JSON.stringify(
    SetRemoteSessionAutoRefreshPolicyRequest$outboundSchema.parse(
      setRemoteSessionAutoRefreshPolicyRequest,
    ),
  );
}
